import WebGLApplication from './WebGLApplication';

export default WebGLApplication;
